__turbopack_context__.v({
  "ghost": "styles-module__48BpXW__ghost",
  "outline": "styles-module__48BpXW__outline",
  "primary": "styles-module__48BpXW__primary",
  "shadow": "styles-module__48BpXW__shadow",
  "size48": "styles-module__48BpXW__size48",
  "size72": "styles-module__48BpXW__size72",
  "white": "styles-module__48BpXW__white",
});
